export default {
  blik__title: 'Dokończ płatność przelewem BLIK',
  blik__intro: 'Aby dokończyć płatność, wykonaj przelew na poniższy numer telefonu.',
  blik__time_remaining: 'Pozostały czas',
  blik__amount_label: 'Kwota do przelania',
  blik__phone_label: 'Numer telefonu odbiorcy',
  blik__full_name_label: 'Imię i nazwisko odbiorcy',
  blik__warning:
    'Uwaga! Podane dane są jednorazowe i ważne tylko przez wyświetlony czas. Prosimy o przelanie dokładnej kwoty wskazanej w podsumowaniu. Płatność po upływie wyznaczonego czasu lub ponowne wykorzystanie tych samych danych doprowadzi do nieodwracalnej utraty środków.',
  blik__step_1: 'Skopiuj dane do płatności wyświetlone na ekranie.',
  blik__step_2: 'Otwórz aplikację mobilną swojego banku (lub bankowość internetową).',
  blik__step_3: 'Znajdź i wybierz opcję „Przelew na telefon BLIK”.',
  blik__step_4: 'Wpisz numer telefonu:',
  blik__step_5: 'Sprawdź, czy imię i nazwisko odbiorcy się zgadzają:',
  blik__step_6: 'Kwota przelewu musi być identyczna z kwotą podaną w oknie płatności:',
  blik__step_6_note:
    'W przypadku wysłania innej kwoty konieczny będzie kontakt ze sprzedawcą w celu zaksięgowania wpłaty.',
  blik__step_7:
    'Po wysłaniu przelewu kliknij przycisk „Przelew wykonany”, aby sprawdzić status swojej transakcji.',
  blik__btn_confirm: 'Przelew wykonany',
  blik__note_1: 'Jeśli nie wykonasz przelewu, płatność nie zostanie potwierdzona.',
  blik__note_2: 'Jeśli instrukcja wygaśnie, utwórz nową płatność i spróbuj ponownie.',
  blik__waiting_title: 'Płatność przyjęta',
  blik__waiting_subtitle: 'Czekamy na zaksięgowanie Twojego przelewu. Może to potrwać kilka minut.',
  blik__waiting_note: 'Sprzedawca otrzyma ostateczny status płatności po zaksięgowaniu środków.',
  blik__waiting_btn_return: 'Wróć do sklepu',
  blik__confirm_error: 'Nie udało się potwierdzić płatności. Spróbuj ponownie.',
  blik__expired: 'Ta instrukcja wygasła. Utwórz nową płatność i spróbuj ponownie.',
};
